import { render, staticRenderFns } from "./ChaperoneRoster.vue?vue&type=template&id=618689f5&scoped=true&"
import script from "./ChaperoneRoster.vue?vue&type=script&lang=js&"
export * from "./ChaperoneRoster.vue?vue&type=script&lang=js&"
import style0 from "./ChaperoneRoster.vue?vue&type=style&index=0&id=618689f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618689f5",
  null
  
)

export default component.exports